module.exports = __webpack_public_path__ + "static/a1d1hub-video-6f97570ea4948a429018970465d73e96.png";